import { BAID_MATCHER, BSNID_MATCHER } from '../matchers';

interface ApiProps {
  serviceNowIdentifier: string | null;
  severityClassification: string | null;
  piiExposed: boolean | null;
  gdprCompliant: boolean | null;
}

/**
 * Checks if the API has all the information required to create a ServiceNow access request.
 */
export function hasRequiredServiceNowInformation(api: ApiProps): boolean {
  return (
    validServiceNowIdentifier(api.serviceNowIdentifier) &&
    api.severityClassification !== null &&
    api.piiExposed !== null
  );
}

function validServiceNowIdentifier(identifier: string | null) {
  return identifier !== null && (BAID_MATCHER.test(identifier) || BSNID_MATCHER.test(identifier));
}
